import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dca06c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-search-page" }

import { FilterView, ProductView } from '@/components/main';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSearchPage',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ProductView)),
    _createVNode(_unref(FilterView))
  ]))
}
}

})